import {
    Button,
    Card,
    CardActions,
    CardContent,
    CardMedia,
    Rating,
    Typography,
  } from "@mui/material";
  import React from "react";
  import "./MovieCard.css";
  import { ConnectingAirportsOutlined } from "@mui/icons-material";
  import moment from 'moment';
  import {  Link } from "react-router-dom";
  import { config } from "../App";
  import ipConfig from "../ipConfig.json";
  const MovieCard = ({ product }) => {
  
      
      let videoUrl =`/video/${product._id}`;
      return (
        
        <Link to = {videoUrl} style={{textDecoration:"none"}}>
        <Card className="card" sx={{borderRadius:'0', backgroundColor:'#181818', border:'0', boxShadow:'0', p:'0', m:'0'}}>
            <CardMedia 
              component="img"
              image={product.previewImage}
              alt={product.title}
              
            />
            <CardContent className="card-content" sx={{p:1, fontSize:'0.8rem', textAlign:'left'}}>
              <Typography sx={{color:'white', fontSize:'0.8rem'}}>
              {product.title}
              </Typography>
              <Typography sx={{color:'white',fontSize:'0.8rem'}}>
              {moment(product.releaseDate).fromNow()}
               
              </Typography>
            </CardContent>
      </Card>
        </Link>
      );
    };
    
    export default MovieCard;
    